<template>
  <div class="blinker" v-html="typedText"></div>
</template>
 
<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    speed: {
      type: Number,
      default: 10000,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    typedText() {
      return this.text.substring(0, this.currentIndex);
    },
  },
  mounted() {
    this.typeText();
  },
  methods: {
    typeText(speed = 50) {
      if (this.currentIndex <= this.text.length) {
        setTimeout(() => {
          this.currentIndex++;
          this.typeText();
        }, speed);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.typing::after {
  content: "▌";
}
.blinker::after {
  animation: blinker 1s step-end infinite;
}
@keyframes blinker {
  0% {
    visibility: visible;
  }
  50% {
    visibility: hidden;
  }
  100% {
    visibility: visible;
  }
}
</style>
